import React, {Component} from 'react';
import {
  Container,
  Row,
  Col,
  CardGroup,
  Card,
  CardBody,
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText, ButtonToolbar, ButtonGroup
} from 'reactstrap';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import * as helper from 'App/util/common/helper';

import {
  actions as authActions
} from 'App/util/redux/auth/index';
import {withApollo} from 'react-apollo';
import {Link} from 'react-router-dom';

const {
  authLogin,
} = authActions;

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  authLogin: (login, origin, pass, cb_success) => {
    dispatch(authLogin(login, origin, pass, cb_success))
  }
});

@compose(
  withApollo,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)
class Login extends Component {
  state = {
    password: '',
    login: '',
    origin: 'esid',
  };

  handleSubmit(event) {
    event.preventDefault();

    const {login, password, origin} = this.state;
    this.props.authLogin(login, origin, password, (dispatch, user) => helper.cb_login(dispatch, user));
  }

  handleChange = (event) => {
    this.setState(helper.handleInputChange(event));
  };

  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <Button color="primary" tag={Link} to={'/'} className="px-4">&larr; Back to Homepage</Button>
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <h1>Login</h1>
                    <p className="text-muted">Sign In to your account</p>
                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="icon-user"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input type="text" placeholder="Username" autoFocus
                             onChange={::this.handleChange}
                             name="login"
                      />
                    </InputGroup>
                    <InputGroup className="mb-4">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="icon-lock"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input type="password" placeholder="Password" name="password"
                             onChange={::this.handleChange}
                             value={this.state.password}/>
                    </InputGroup>
                    <div className='py-4'>
                      <p>
                        <b>Note:</b><br/>
                        The public pages include aggregated data from ESID and affiliated centers.<br/>
                        The members area shows data from the ESID Registry database <b>only</b>.
                        <br/><br/>
                        Please select system your account belongs to, i.e. the registry system in which you are
                        documenting.
                      </p>
                      <ButtonGroup>
                        <Button value='esid' name='origin' onClick={::this.handleChange}
                                active={this.state.origin === 'esid'}>ESID</Button>
                        <Button value='ukpid' name='origin' onClick={::this.handleChange}
                                active={this.state.origin === 'ukpid'}>UK-PID</Button>
                      </ButtonGroup>
                    </div>
                    <Row>
                      <Col xs="6">
                        <Button color="primary" className="px-4" onClick={::this.handleSubmit}>Login</Button>
                      </Col>
                      <Col xs="6" className="text-right">
                        {/* <Button color="link" className="px-0">Forgot password?</Button> */}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js